import { render, staticRenderFns } from "./FooterMsgForStore.vue?vue&type=template&id=c281bf94"
import script from "./FooterMsgForStore.vue?vue&type=script&lang=ts"
export * from "./FooterMsgForStore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports